import { getHousings } from "../../../../api/housing";

export const ROOM_FIELDS = [  
  { key: "snf_certified", label: "snf_certified" },
  { key: "max_persons", label: "max_persons", type: "number" },
  { key: "picture", label: "picture", type: "file" },
]

export const ROOM_REQUIRED_FIELDS = [
  {
    key: "number",
    label: "House Number",
    type: "select",
    apiResKey: "housings",
    api: getHousings,
    disabled: true
  },
  { key: "room_number", label: "room_number" },
  { key: "target_price", label: "target_price" },
];

export const FIELDS = [...ROOM_REQUIRED_FIELDS, ...ROOM_FIELDS]


export const INFO_FIELDS = [
  { key: "room_number", label: "Room Number"},
  { key: "snf_certified", label: "SNF Certified"},
  { key: "max_persons", label: "Max People"},
  { key: "capacity", label: "Reservations"},
  { key: "target_price", label: "Target Price", type: 'price'},
  { key: "housing", label: "Housing", nested: [
    { key: "street_name", label: "Street Name"},
    { key: "number", label: "Street Number"},
    { key: "city", label: "City"},
    { key: "postal_code", label: "Postal Code"},
  ]},
];